import { useState } from 'react';
import CardLayout from '../../../components/Layout/CardLayout';
import ReactDataTable from '../../../components/ReactDataTable/ReactDataTable';
import useFetch from '../../../hooks/useFetch';
import request from '../../../request/request';
import ModalLayout from '../../../components/Layout/ModalLayout';
// import { formDataConverter } from '../../../utils/necessaryFunctions';
import EditButton from '../../../components/Button/EditButton';
import DeleteButton from '../../../components/Button/DeleteButton';
import DeleteModal from '../../../components/Modal/DeleteModal';
import BookingForm from '../../../components/Forms/Websites/Booking/BookingForm';
// import VisaForm from '../../../components/Forms/Websites/Visa/VisaForm';

const Booking = () => {
    const [modalOpen, setModalOpen] = useState('');
    const [selectedItem, setSelectedItem] = useState('');

    const { result, isLoading, setRefresh } = useFetch(() => request.getAll('booking'));

    const columns = [
        {
            name: 'Name',
            center: 'true',
            selector: (row) => row?.name,
        },
        {
            name: 'Phone',
            center: 'true',
            selector: (row) => row?.phone,
        },
        {
            name: 'Email',
            center: 'true',
            selector: (row) => row?.email,
        },
        {
            name: 'Tour Id',
            center: 'true',
            selector: (row) => row?.tour_id,
        },
        // {
        //     name: 'Image',
        //     width: '100px',
        //     cell: (row) => (
        //         <img
        //             style={{ width: '100%' }}
        //             // src={`url(${process.env.REACT_APP_UPLOAD_URL}/website/${row?.image})`}
        //             src={`${process.env.REACT_APP_UPLOAD_URL}/website/${row?.image}`}
        //             alt='side Img'
        //         />
        //     ),
        // },
        // {
        //     name: 'Price',
        //     wrap: true,
        //     center: 'true',
        //     selector: (row) => row?.price,
        // },
        // {
        //     name: 'Status',
        //     center: 'true',
        //     selector: (row) => (row?.status === 1 ? 'Active' : 'InActive'),
        // },
        {
            name: 'Status',
            center: 'true',
            // selector: (row) => row?.status,
            selector: (row) => (row?.status === 1 ? 'Complete' : 'Pendding'),
        },
        {
            name: 'Active',
            center: 'true',
            cell: (row) => (
                <div>
                    <EditButton
                        onClick={() => {
                            setModalOpen('update');
                            setSelectedItem(row);
                        }}
                    />
                    <DeleteButton
                        onClick={() => {
                            setModalOpen('delete');
                            setSelectedItem(row);
                        }}
                    />
                </div>
            ),
        },
    ];

    // create new function

    const createNewServiceHandler = (formValue) => {
        // const formData = formDataConverter(formValue);
        const formData = formValue;

        request.create('booking', formData, () => {
            setModalOpen('');
            setRefresh((prev) => !prev);
        });
    };

    // update

    const updateServiceHandler = (formValue) => {
        // const formData = formDataConverter(formValue);
        const formData = formValue;

        request.updateOne('booking', selectedItem?.id, formData, () => {
            setModalOpen('');
            setRefresh((prev) => !prev);
        });
    };

    // delete

    const deleteServiceHandler = () =>
        request.delete('booking', selectedItem?.id, () => {
            setModalOpen('');
            setRefresh((prev) => !prev);
        });

    return (
        <CardLayout
            title='Booking List'
            buttonTitle='Add New Booking'
            addButtonHandler={() => setModalOpen('create')}
        >
            <ReactDataTable data={result} columns={columns} pending={isLoading} />
            {/*= ============== create ===================== */}

            {modalOpen === 'create' && (
                <ModalLayout
                    isOpen={modalOpen === 'create'}
                    onClose={() => setModalOpen('')}
                    title='Create New Booking'
                    size='lg'
                >
                    <BookingForm apiHandler={createNewServiceHandler} />
                </ModalLayout>
            )}

            {/* ======================= update ========================== */}

            {modalOpen === 'update' && (
                <ModalLayout
                    isOpen={modalOpen === 'update'}
                    onClose={() => setModalOpen('')}
                    title='Update New Booking'
                    size='lg'
                >
                    <BookingForm apiHandler={updateServiceHandler} editData={selectedItem} />
                </ModalLayout>
            )}

            {/* ======================= delete ========================== */}

            {modalOpen === 'delete' && (
                <DeleteModal
                    isOpen={modalOpen === 'delete'}
                    onClose={() => setModalOpen('')}
                    handleDelete={deleteServiceHandler}
                />
            )}
        </CardLayout>
    );
};

export default Booking;
